import script from "./InputWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./InputWrapper.vue?vue&type=style&index=0&id=0797bcd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0797bcd8"]])

export default __exports__